import { colors } from '@ui/colors'
import ConfirmationModal from '@ui/components/ConfirmationModal'
import { useTranslation } from 'react-i18next'

interface Props {
  open: boolean
  onAdjust: () => void
  onRepeat: () => void
  /** Backdrop dismiss — leaves the measurement as it is, unlike `onRepeat`. */
  close: () => void
}

export default function Proposal({ open, onAdjust, onRepeat, close }: Props) {
  const { t } = useTranslation(['measurement'])
  const tl = 'measurement:app.manual.proposal'

  return (
    <ConfirmationModal
      open={open}
      onConfirm={onAdjust}
      onClose={close}
      onCancel={onRepeat}
      title={t(`${tl}.header.title`)}
      desc={t(`${tl}.header.desc`)}
      confirmLabel={t(`${tl}.actions.confirm.label`)}
      cancelLabel={t(`${tl}.actions.cancel.label`)}
      buttonConfirmProps={{
        variant: 'outlined',
        colors: [colors.white, colors.red[100]],
        overrideColorFront: colors.red[600],
        className: 'border-red-700',
      }}
    />
  )
}
